export default __webpack_public_path__ + "static/media/qr-icon14.5379e2ea.png";